export default __webpack_public_path__ + "66d3870a26e88988f9a275c0a2941ef4.png";